var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":"Button1","type":"button","value":"浏览器所有信息","name":"Button1","language":"javascript"},on:{"click":_vm.allinfo}}),_c('div',{attrs:{"id":"elInfo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }